import { render, staticRenderFns } from "./StatisticsDescMyOwn.vue?vue&type=template&id=4eb2e97f&"
import script from "./StatisticsDescMyOwn.vue?vue&type=script&lang=js&"
export * from "./StatisticsDescMyOwn.vue?vue&type=script&lang=js&"
import style0 from "./StatisticsDescMyOwn.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports